module.exports = __webpack_public_path__ + "assets/sofort-ueberweisung.e0482820.png";